import { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/DatePicker.module.css';

const datePicker = (props) =>{
  const [curDateIndex, setCurDateIndex] = useState(0);
  //console.log('props=', props)

  const nextMonth = () => {
    setCurDateIndex(curDateIndex-1);
  }

  const lastMonth = () => {
    setCurDateIndex(curDateIndex+1);
  }

  const handleSelect = (value) => {
    props.selectmonth(value);
  }

  const renderPicker = (availableDates) => {
    
    //return;
    if (availableDates && availableDates.length > 0) {
      let rows = [];
      let yy = availableDates[curDateIndex].yy;
      let mm = availableDates[curDateIndex].mm;
      //btn control
      let showLastMonthBtn = (curDateIndex + 1 < availableDates.length) ? true : false ;
      let showNextMonthBtn = (curDateIndex > 0) ? true : false ;
      //loop for month
      for (let i = 0; i < mm.length; i++) {
        
        let styleClass = styles.monthBtn;
        if(props.currentmonth != "" && props.currentmonth == yy+'-'+mm[i]){
          styleClass = styles.monthBtnSelected;
        }
        
        rows.push(
          <Col lg={3} xs={3} style={{padding:0}} key={i}>
            <div className={styleClass} onClick={()=>{handleSelect(yy+'-'+mm[i])}}>{mm[i]}月</div>
          </Col>
        );     
      }

      return (
        <div>
          <Container>
            <Row>
              <Col xs={4}>
                {showLastMonthBtn && <div className={styles.arrowBtn} onClick={lastMonth}>&#8592;</div>}
              </Col>
              <Col xs={4}><div className={styles.year}>{yy}</div></Col>
              <Col xs={4}>
                {showNextMonthBtn && <div className={styles.arrowBtn} onClick={nextMonth}>&#8594;</div>}
              </Col>
            </Row>
          </Container>
          
          <Container className={styles.pickerHolder}><Row>{rows}</Row></Container>
        </div>
      );
    }
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          選擇月份
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderPicker(props.data)}
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>關閉</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default datePicker;